import * as yup from "yup";
import { TFunction } from "i18next";

export const staffFormSchema = (t: TFunction) =>
  yup.object().shape({
    // positions: yup.array().min(1, t("validation.required")),
    // positionEn: yup.string().max(250, t("validation.more250")),
    method: yup
      .string()
      .nullable()
      // .max(250, t("validation.more250"))
      .required(t("validation.required")),
    methodEn: yup
      .string()
      .nullable()
      // .max(250, t("validation.more250"))
      .required(t("validation.required")),
    // StandardCountIndicatorId: yup.object().shape({
    //   label: yup
    //     .string()
    //     .min(1, t("validation.more250"))
    //     .required(t("validation.required")),
    //   value: yup.string().nullable().required(t("validation.required")),
    // }),
    // StandardCertificationIndicatorId: yup.object().shape({
    //   label: yup
    //     .string()
    //     .min(1, t("validation.more250"))
    //     .required(t("validation.required")),
    //   value: yup.string().nullable().required(t("validation.required")),
    // }),
    // StandardTrainingIndicatorId: yup.object().shape({
    //   label: yup
    //     .string()
    //     .min(1, t("validation.more250"))
    //     .required(t("validation.required")),
    //   value: yup.string().nullable().required(t("validation.required")),
    // }),
    positions: yup.array().min(1, t("validation.required")),
  });
